/* LUCIELL – kicker-Listicle 2: Bewertungskarten zum Wischen (Pfeile am Desktop) und „Mehr lesen“. */
(function () {
  var r = document.querySelector('[data-lc-kl]');
  if (!r) return;
  var band = r.querySelector('[data-lc-kl-band]');

  r.addEventListener('click', function (e) {
    var pfeil = e.target.closest('[data-lc-kl-pfeil]');
    if (pfeil && band) {
      var karte = band.querySelector('.lc-kl-karte');
      var schritt = karte ? karte.getBoundingClientRect().width + 12 : 300;
      band.scrollBy({ left: schritt * Number(pfeil.getAttribute('data-lc-kl-pfeil')), behavior: 'smooth' });
      return;
    }
    var mehr = e.target.closest('[data-lc-kl-mehr]');
    if (mehr) {
      var text = mehr.previousElementSibling;
      var offen = text.classList.toggle('ist-offen');
      mehr.textContent = offen ? 'Weniger' : 'Mehr lesen';
    }
  });

  // „Mehr lesen“ nur dort zeigen, wo der Text wirklich abgeschnitten ist.
  function pruefen() {
    r.querySelectorAll('[data-lc-kl-text]').forEach(function (t) {
      var knopf = t.nextElementSibling;
      if (!knopf || t.classList.contains('ist-offen')) return;
      knopf.hidden = t.scrollHeight <= t.clientHeight + 2;
    });
  }
  pruefen();
  window.addEventListener('load', pruefen);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pruefen);
  window.addEventListener('resize', pruefen);
})();
